import {ZITI_DATA_SERVICE, ZitiDataService, ExtensionService, GrowlerService} from "ziti-console-lib";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnChanges,
  SimpleChanges,
  Inject,
} from '@angular/core';
import {isEmpty, cloneDeep, unset} from 'lodash';
import _ from 'lodash';
import {ActivatedRoute, Router, NavigationEnd} from "@angular/router";
import {Location} from "@angular/common";
import { TcpShare } from '@netfoundry-ui/shared/model';
import { ApiService, LoggerService, ShareService, AgentService, ClientCertificateService, AuthProviderService } from "@netfoundry-ui/shared/services";

import { Subscription, Subject } from "rxjs";
import { GrowlerData } from "@netfoundry-ui/shared/growler";

@Component({
    selector: 'app-tcp-share-form',
    templateUrl: './tcp-share-form.component.html',
    styleUrls: ['./tcp-share-form.component.scss'],
    standalone: false
})
export class TcpShareFormComponent implements OnInit, OnChanges {
  @Input() isModal = false;
  @Input() formData: any = {};
  close: EventEmitter<any> = new EventEmitter<any>();

  isEditing = false;

  formView = 'simple';
  isV2 = true;

  errMap:  any = {};
  timeout = Date.now() + 10 * 60 * 1000; 

  saveSubject = new Subject<boolean>;
  mappingConfigUpdateSubject = new Subject<boolean>;
  agentList;
  clientCertificateList;
  providerList;
  selectedCertificate

  moreActions: any[] = [];
  protected isLoading = false;
  initData: any = {};
  @Output() dataChange: EventEmitter<any> = new EventEmitter<any>();
  _dataChange = false;
  public errors: any = {};
  basePath = '';
  previousRoute;
  errorState = false;
  protected usePreviousLocation = true;
  subscription: Subscription = new Subscription();
  @Input() entityId: string;
  baseHref: any;
  formInit = false;
  frontdoorId: string;
  agentError = false;
  clientCertError = false;
  IngressPortError = false;
  nameError = false;
  targetError = false
  agentErrorMessage
  IngressPortMessage
  nameErrorMessage
  clientCertErrorMessage
  targetErrorMessage
  frontendsErrorMessage
  certificateTypes = ['System Generated Certificate', 'Client Certificate']
  
  processing = false;
  constructor(
      private apiService: ApiService,
      public agentService: AgentService,
      private logger: LoggerService,
      public svc: ShareService,
      private growlerService: GrowlerService,
      public clientCertificateService: ClientCertificateService,
      public authProviderService: AuthProviderService,
      @Inject(ZITI_DATA_SERVICE) protected zitiService: ZitiDataService,
      private location: Location,
      protected router?: Router,
      protected route?: ActivatedRoute,
  ) {
    this.previousRoute = router?.getCurrentNavigation()?.previousNavigation?.finalUrl?.toString();
        this.subscription.add(
            this.route?.params?.subscribe(params => {
                const id = params['id'];
                if (isEmpty(id)) {
                    this.entityId = 'create';
                } else {
                  this.entityId = id;
                }
            })
        );
        this.subscription.add(
            router?.events.subscribe((event: any) => {
                  if (!event?.snapshot?.routeConfig?.path) {
                      return;
                  }
                  const pathSegments = event.snapshot.routeConfig.path.split('/');
                  this.basePath = pathSegments[0];
                
            })
        );
        this.initBaseHref();
  }

  ngOnInit(): void {
      this.subscription.add(
          this.apiService.currentTenant.subscribe((tenant) => {
              this.agentService.getAccountById(tenant.id).subscribe((frontdoor: any) => {
                  this.frontdoorId = frontdoor.id;
                  this.getAgents()
                  this.getClientCertificates()
                  if (this.entityId === 'create') {
                      this.formData = new TcpShare();
                      this.selectedCertificate = 'Client Certificate'
                      this.initData = cloneDeep(this.formData);
                      this.entityUpdated();
                      return;
                  } else {
                      this.isEditing = true;
                      this.isLoading = true;
                      this.getTcpShare();
                  }
              })
          })
      );
      this.formInit = true;
  }

  
  getTcpShare() {
    return this.svc.getTcpShare(this.frontdoorId, this.entityId).subscribe({
      next: (entity: TcpShare) => {
        this.formData = entity;
        this.formData.envId = entity.envZId;
        if(this.formData.clientCertificateId) {
          this.selectedCertificate = 'Client Certificate'
        } else if (this.formData.useIntermediateCertificate) {
          this.selectedCertificate = 'System Generated Certificate'
        }
        this.initData = cloneDeep(this.formData);
        this.entityUpdated();
        this.isLoading = false;
      },
      error: (err) => {
        this.growlerService.show(
        new GrowlerData(
            'error',
            'Error',
            'Error retrieving tcp share data.',
        )
    );
      this.isLoading = false;
      }
    })
  }

  ngOnChanges(changes: SimpleChanges) {
    this.isEditing = !isEmpty(this.formData.id);
  }

    getAgents() {
        this.agentService.getAgentsByEnv(this.frontdoorId, true).subscribe((agents: any) => {
            this.agentList = agents._embedded.environmentList;
        })
    }

  initBaseHref() {
        try {
            const base = document?.querySelector('base');
            this.baseHref = base ? base.getAttribute('href') : '/';
        } catch (error) {
            this.baseHref = '/';
        }
    }

  entityUpdated() {
    if (this.formData.id) {
    }
    
    unset(this.formData, '_links');
    this.initData = cloneDeep(this.formData);
  }

  headerActionRequested(action: any) {
    switch(action.name) {
      case 'save':
        this.save();
        break;
      case 'close':
        this.closeForm();
        break;
      case 'toggle-view':
        this.formView = action.data;
        break;
    }
  }


onCertificateTypeChange(type: string) {
  this.selectedCertificate = type;
  if (type === 'System Generated Certificate') {
    unset(this.formData, 'clientCertificateId');
  } else {
    unset(this.formData, 'allowedSubjects');
    unset(this.formData, 'allowedCommonNamePrefixes');
    unset(this.formData, 'organizationalUnit');
    unset(this.formData, 'useIntermediateCertificate');
  }
  this.clientCertError = false;
}

save(event?: any) {
  this.processing = true;
  this.isLoading = true;

  if (this.selectedCertificate === 'System Generated Certificate') {
    this.formData.useIntermediateCertificate = true;
  } else {
    unset(this.formData, 'useIntermediateCertificate');
  }

  const proms = [];

  // 1. Handle Subject logic for Editing mode
  if (this.isEditing) {
    this.saveSubject.next(true);
    const updateSubjectPromise = new Promise<boolean>((resolve) => {
      // Note: Consider taking(1) so this doesn't hang
      this.mappingConfigUpdateSubject.asObservable().subscribe((wasUpdated: boolean) => {
        resolve(wasUpdated);
      });
    });
    proms.push(updateSubjectPromise);
  } else {
    // If not editing, we push 'true' so the Promise.all logic stays consistent
    proms.push(Promise.resolve(true));
  }

  // 2. Branch between Create and Update
  // We wrap the observable in toPromise() or use a new Promise wrapper 
  // so Promise.all can actually track it.
  const httpCall = this.isEditing 
    ? this.svc.updatetcp(this.frontdoorId, this.formData,  this.formData.id)
    : this.svc.createtcp(this.frontdoorId, this.formData);

  const requestPromise = new Promise((resolve, reject) => {
    httpCall.subscribe({
      next: (result: any) => {
        if (this.isModal) {
          this.closeModal(true, true);
        } else {
          this.initData = this.formData;
          this.formData = result;
          this._dataChange = false;
        }
        resolve(true);
      },
      error: (err) => {
        this.processErrors(err);
        this.isLoading = false;
      }
    });
  });

  proms.push(requestPromise);

  // 3. Finalize
  Promise.all(proms)
    .then((results) => {
      // results[0] is the Subject, results[1] is the HTTP call
      if (results[0] === true && results[1] === true) {
        this.returnToListPage();
        // TODO: Success message
      }
    })
    .catch(err => {
      // Handle errors here
    })
    .finally(() => {
      this.processing = false;
      this.isLoading = false;
    });
}

  validate() {
    this.errMap = {};
    if (isEmpty(this.formData.name)) {
      this.errMap['nameRequired'] = true;
    }
    
    return isEmpty(this.errMap);
  }

      onKeyDown(event: KeyboardEvent) {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            event.stopPropagation();
            const element = event.target as HTMLElement;
            element.blur();
            element.focus();
        }
    }


  
  clear(): void {
  }

  closeModal(refresh = true, ignoreChanges = false, data?: any, event?: any): void {
    this.close.emit({refresh: refresh});
    if (event) {
        event.stopPropagation();
    }
  }

  closeForm(refresh = true, ignoreChanges = false, data?, event?) {
      if (!ignoreChanges && this._dataChange) {
          const confirmed = confirm('You have unsaved changes. Do you want to leave this page and discard your changes or stay on this page?');
          if (!confirmed) {
              return;
          }
      }
      if (this.isModal) {
          this.closeModal(refresh, ignoreChanges);
      } else {
          this.returnToListPage();
      }
  }

      getClientCertificates() {
        this.clientCertificateService.getClientCertificates(this.frontdoorId, this.isV2).subscribe((data: any) => {
        this.clientCertificateList = data._embedded.clientCertificateList;
        })
    } 


    getAuthProviders() {
  this.authProviderService.getAuthProviders(this.frontdoorId, this.isV2).subscribe((data: any) => {
    if (data._embedded) {
        this.providerList = data._embedded.authProviderList; 
    }
  });
}

    processErrors(errorResponse: any) {
            const errors: string[] = errorResponse?.error?.errors || [];
            const envZIdError = errors.find(e => e.includes('envZId'));
            const targetError = errors.find(e => e.includes('target'));
            const ingressPortError = errors.find(e => e.includes('ingressPort'));
            const nameError = errors.find(e => e.includes('name'));
            const clientCertError = errors.find(e => e.includes('clientCertificateId'))
            const acrossAccountError = errorResponse?.status === 409
            const nameTooShortError = errorResponse?.status === 422
            if(envZIdError) {
                this.agentError = true;
                this.agentErrorMessage =  envZIdError.split(':').slice(1).join(':').trim();
            }
            if(targetError) {
                this.targetError = true;
                this.targetErrorMessage =  targetError.split(':').slice(1).join(':').trim();
            }
            if(ingressPortError) {
                this.IngressPortError = true;
                this.IngressPortMessage =  ingressPortError.split(':').slice(1).join(':').trim();
            }
            if(nameError) {
                this.nameError = true;
                this.nameErrorMessage =  nameError;
            }
            if(clientCertError) {
                this.clientCertError = true;
                this.clientCertErrorMessage =  clientCertError.split(':').slice(1).join(':').trim();
            } 
            if(acrossAccountError) {
                           this.growlerService.show(
                        new GrowlerData(
                            'error',
                            'TCP Share create request failed',
                            errorResponse?.error?.detail
                    )
            );
            }
            if(nameTooShortError) {
                           this.growlerService.show(
                        new GrowlerData(
                            'error',
                            'TCP Share create request failed',
                            'Share name but be more than 4 characters.'
                    )
            );
            } else {
                this.growlerService.show(
                        new GrowlerData(
                            'error',
                            'TCP Share create request failed',
                            'Share create request has failed.'
                    )
            );
            }
            
}

  returnToListPage() {
    if (this.location && this.previousRoute && this.usePreviousLocation) {
      this.location.back();
    } else {
      this.router?.navigateByUrl(`${this.basePath}/tcp-shares`);
    }
  }


  mappingConfigUpdateHandler(wasUpdated: boolean) {
    this.mappingConfigUpdateSubject.next(wasUpdated);
  }

  


    /**
     * True when this form is showing an existing entity. Derived from the route/input
     * rather than the loaded record, so the header title doesn't briefly read
     * "Create New ..." while the record is still being fetched.
     */
    get isExistingEntity(): boolean {
        return !isEmpty(this.formData?.id) || (!isEmpty(this.entityId) && this.entityId !== 'create');
    }

}